/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import { Label, SVGIcon } from 'ca-ui-toolkit';
import PropTypes from 'prop-types';
import '../stylesheets/slotEditorEmptyState.scss';

class SlotEditorEmptyState extends Component{
	constructor(props){
		super(props);
	}

	render() {
		const icon = this.renderIcon();
		const title = this.renderTitle();
		const description = this.renderDescription();

		const alignment = this.props.alignment;
		const styles = {
			'align-items': alignment ? alignment : 'center',
			'text-align': alignment ? alignment : 'center'
		};

		return (
			<div className="slotEditorEmpty" style = {styles}>
				<div className="slotEditorEmpty__container">
					{icon}
					{title}
					{description}
				</div>
			</div>
		);
	}

	renderIcon() {
		if(this.props.iconId) {
			return (
				<div className="slotEditorEmpty__icon">
					<SVGIcon iconId={this.props.iconId} size="xxlarge" />
				</div>
			);
		}
		return null;
	}

	renderTitle() {
		if (this.props.title) {
			return (
				<Label label={this.props.title} className="slotEditorEmpty__title" />
			);
		}
		return null;
	}

	renderDescription() {
		if (this.props.description) {
			const description = this.props.description;
			return (
				<Label label={description} className="slotEditorEmpty__description" />
			);
		}
		return null;
	}
}

SlotEditorEmptyState.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	iconId: PropTypes.string,
	alignment: PropTypes.string
};

SlotEditorEmptyState.defaultProps = {
	title: null,
	iconId: null,
	description: null,
	alignment: null
};

export default SlotEditorEmptyState;



// WEBPACK FOOTER //
// ./src/js/SlotEditorEmptyState.js